module.exports = __webpack_public_path__ + "img/outer-8.f5617a39.png";